<!-- <div class="mat-elevation-z8">
    <table mat-table [dataSource]="gridOptions.data">
     <ng-container *ngFor="let col of gridOptions.columnDefs">
         <th mat-header-cell *matHeaderCellDef>{{ col.headerName }}</th>
         <td mat-cell *matCellDef="let element">
             <span [innerHTML]="col.cellRenderer ? col.cellRenderer(element) : getField(element, col.field)"></span>
         </td>
     </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>
    </table>
  
    <mat-paginator [pageSizeOptions]="[50, 100, 200]"
                   showFirstLastButtons 
                   aria-label="Select page ">
    </mat-paginator>
  </div>
 -->

<p-table [columns]="gridOptions.columnDefs" #dt

[showCurrentPageReport]="true"
currentPageReportTemplate="{first} to {last} of {totalRecords}"
[paginator]="gridOptions.pagination && (gridOptions?.data?.length >= 10) " [rows]="50"
[rowsPerPageOptions]="[10, 25, 50, 100, 200]"

[rowHover]="true"
[autoLayout]="true" 
[value]="gridOptions.data" 
responsiveLayout="scroll"
[styleClass]="styleClass()" 

[dataKey]="dataKey()"
(onHeaderCheckboxToggle)="selectAll($event)"
[(selection)]="mySelections"
(onRowSelect)="onRowSelect($event)" 
(onRowUnselect)="onRowUnselect($event)"
[selectionMode]="gridOptions.rowSelection || 'single'"
(sortFunction)="customSort($event)" [customSort]="true"
[sortField]="gridOptions.sortField"
>
    <ng-template #caption *ngIf="gridOptions.rowExpandComponent">
        <div class="d-flex justify-content-end p-2">
            <p-button label="Expand All" icon="pi pi-plus" text (onClick)="expandAll()" />
            <p-button label="Collapse All" icon="pi pi-minus" text (onClick)="collapseAll()" />
        </div>
    </ng-template>
    <ng-template *ngIf="showHeader" pTemplate="caption">
     
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="gridOptions.columnDefs.length + 10"
            style="text-align:center" 
            [innerHTML]="gridOptions.overlayNoRowsTemplate || 'No Data'"></td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" >
        <tr>
            <td [attr.colspan]="gridOptions.columnDefs.length + 10"
            [innerHTML]="gridOptions.overlayLoadingTemplate || 'Loading'"
            >

            </td>
        </tr>
    </ng-template>
    <ng-template  pTemplate="header" let-columns>
        <tr >
            <th *ngIf="gridOptions.columnDefs.length && gridOptions.columnDefs?.[0].checkboxSelection" style="width:1em" class="px-3">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> 
            <th *ngFor="let col of columns" [pSortableColumn]="getSortField(col)">
                {{col.headerName}} <p-sortIcon *ngIf="(col.sortable !== false) && getSortField(col)" [field]="getSortField(col)"></p-sortIcon>
            </th>
            <th *ngIf="gridOptions.deleteRowButton" style="width:1em">
               
            </th> 
        </tr>
        <tr *ngIf="gridOptions.filters">
            <th *ngFor="let col of columns">
                <p-columnFilter
                        type="text"
                        [field]="col.field"
                       
                        />
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData 
    let-columns="columns" let-rowIndex="rowIndex"
    let-expanded="expanded"
    >
        <tr
        [ngClass]="rowData.disabled ? 'disabled' : ''" 
        (dblclick)="rowData.disabled ? null : onDoubleClick(rowData)"
        [pSelectableRow]="rowData.disabled ? null : rowData"
        (mouseenter)="hover(true , rowData)"
        (mouseleave)="hover(false, rowData)" 
        (contextmenu)="onContextMenu(rowData, $event)"
        >
            <td *ngIf="gridOptions.columnDefs?.length &&  (gridOptions.columnDefs[0].checkboxSelection || gridOptions.rowExpandComponent)">
                <p-tableCheckbox [ngClass]="rowData.disabled ? 'invisible' : ''"  *ngIf="gridOptions.columnDefs[0].checkboxSelection " [pSelectableRow]="rowData" [value]="rowData"></p-tableCheckbox>
                <p-button *ngIf="gridOptions.rowExpandComponent" 
                styleClass="text-dark"
                type="button" 
                [pRowToggler]="rowData" 
                [text]="true" 
                [plain]="true" 
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" 
                (onClick)="toggleExpand(rowIndex)"/>
            </td>
            <td *ngFor="let col of columns" [ngClass]="col.className"> 
                <div *ngIf="col.cellButton; else elseCell">
                    <button class="btn btn-link p-0" (click)="col.cellButton($event,rowData)">{{ col.cellRenderer(rowData) }}</button>
                </div>
                <ng-template #elseCell>
                   
                    <div *ngIf="col.cellRenderer; else elseBlock" [innerHTML]="col.cellRenderer(rowData) "></div>
                    <ng-template #elseBlock>
                        <span *ngIf="!col.componentRef; else componentBlock"  >
                            {{ getField(rowData, col.field) }}
                        </span>
                        <ng-template #componentBlock>
                            <div fxContainer [component]="col.componentRef" [params]="rowData" [col]="col" [data]="col.data"></div>
                        </ng-template>
                    </ng-template>
                </ng-template>
               
            </td>
            <th *ngIf="gridOptions.deleteRowButton" style="width:1em">
                <button *ngIf="isSelected(rowData)"
                pButton
                 class="p-button-outlined p-button-secondary border-0" 
                 icon="pi pi-times" (click)="handleCloseClicked(rowData)"></button>
            </th> 
        </tr>
    </ng-template>
    <ng-template #expandedrow let-rowData>
        <tr class="expandedrow">
            <td [attr.colspan]="colLength()">
                <ng-container *ngComponentOutlet="gridOptions.rowExpandComponent; inputs: { rowData: rowData }"
                ></ng-container>
            </td>
        </tr>
    </ng-template>
</p-table>